"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Asset extends _react.default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "subscribed", true);

    _defineProperty(this, "state", {
      value: null
    });
  }

  _fetchAsset() {
    const {
      getAsset,
      path
    } = this.props;
    getAsset(path).then(value => {
      if (this.subscribed) {
        this.setState({
          value
        });
      }
    });
  }

  componentDidMount() {
    this._fetchAsset();
  }

  componentWillUnmount() {
    this.subscribed = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path || prevProps.getAsset !== this.props.getAsset) {
      this._fetchAsset();
    }
  }

  render() {
    const _this$props = this.props,
          {
      component
    } = _this$props,
          props = _objectWithoutProperties(_this$props, ["component"]);

    return _react.default.createElement(component, _objectSpread({}, props, {
      value: this.state.value
    }));
  }

}

_defineProperty(Asset, "propTypes", {
  path: _propTypes.default.string.isRequired,
  getAsset: _propTypes.default.func.isRequired,
  component: _propTypes.default.elementType.isRequired
});

var _default = Asset;
exports.default = _default;